import { useQuery } from '@tanstack/react-query'

import axios from '@shared/utils/axios'

export const useUser = () => {
    const {
        data,
        isLoading
    } = useQuery({
        queryKey: ['user'],
        queryFn: async () => (await axios.get('settings/users/profile')).data,
        retry: 0,
        staleTime: 0,
        refetchOnMount: 'always',
    })

    return {
        ...(data || {}),
        isAuthenticated: isLoading ? null : !!data,
        isLoading
    }
}